
<div>
    <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Dirección</h2>
    <!--h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Dirección de {{ nameService}}</h2-->
    <p class="text-[#3D4E5F] paragraph-default mb-2 w-[335px]">Selecciona la dirección donde recogeremos tu
        auto.</p>
    <div class="flex  text-[#0E365A]">
        <mat-icon>exit_to_app</mat-icon>
        <h3 class="headline-03 p-1">Origen</h3>
    </div>
    <!-- Estado de carga de ubicación -->
    <div *ngIf="isLoadingLocation" class="bg-gray-50 border border-gray-300 rounded-[20px] p-2 flex justify-between items-center mb-2">
        <div class="flex items-center gap-2 text-gray-500">
            <mat-icon class="animate-spin text-sm">refresh</mat-icon>
            <p class="paragraph-medium">Cargando ubicación...</p>
        </div>
    </div>

    <!-- Ubicación actual del mapa -->
    <div *ngIf="currentMapLocation && !isLoadingLocation"
         class="bg-blue-50 border border-[#0E365A] rounded-[20px] p-2 mb-2"
         [class.border-blue-500]="selectedAddress === currentMapLocation">
        <div class="flex justify-between items-center cursor-pointer" (click)="selectAddress(currentMapLocation)">
            <div class="text-[#0E365A]">
                <p class="paragraph-medium flex items-center gap-1">
                    <mat-icon class="text-blue-600 text-sm">my_location</mat-icon>
                    <strong>{{ currentMapLocation.colony }}</strong>
                </p>
                <p class="paragraph-default">{{ currentMapLocation.identifier }}</p>
            </div>
            <button mat-icon-button (click)="toggleEditCurrentLocation($event)">
                <mat-icon style="color: #eca136;">edit</mat-icon>
            </button>
        </div>

        <!-- Buscador desplegable -->
        <div *ngIf="isEditingCurrentLocation" class="mt-3 pt-3 border-t border-blue-200 bg-blue-25">
            <p class="text-xs text-blue-600 mb-2">Busca una dirección y luego ajusta el pin en el mapa:</p>
            <!-- Input de búsqueda integrado -->
            <div class="mb-3">
                <div class="flex items-center bg-white rounded-lg border-2 border-blue-300 shadow-sm">
                    <mat-icon class="text-blue-600 ml-3 text-sm">search</mat-icon>
                    <input
                        class="flex-1 px-3 py-2 text-sm border-none outline-none rounded-lg"
                        type="text"
                        #searchInput
                        placeholder="Buscar dirección..."
                        (input)="onSearchInput($event)"
                    />
                    <mat-icon *ngIf="isSearching" class="text-blue-600 mr-3 animate-spin text-sm">refresh</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="addresses.length > 0">
        <div class="bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] p-2 flex justify-between items-center mb-2 cursor-pointer"
            [class.border-blue-500]="selectedAddress === addresses[0]" (click)="selectAddress(addresses[0])">
            <div class="text-[#0E365A]">
                <p class="paragraph-medium"><strong>{{ addresses[0].identifier }}</strong></p>
                <p class="paragraph-default">{{ addresses[0].streetNumber }}
                    Int {{ addresses[0].interiorDepartament || '' }},
                    {{ addresses[0].colony || '' }},
                    {{ addresses[0].cp || '' }},
                    {{ addresses[0].municipality || '' }},
                    {{ addresses[0].state || '' }}
                </p>
            </div>
            <button mat-icon-button><mat-icon>edit</mat-icon></button>
        </div>
        <div *ngIf="showAllAddresses">
            <div *ngFor="let dir of addresses.slice(1)"
                class="bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] p-2 flex justify-between items-center mb-2 cursor-pointer"
                [class.border-blue-500]="selectedAddress === dir" (click)="selectAddress(dir)">
                <div class="text-[#0E365A]">
                    <p class="paragraph-medium"><strong>{{ dir.identifier }}</strong></p>
                    <p class="paragraph-default">{{ dir.streetNumber || '' }}
                        Int {{ dir.interiorDepartament || '' }},
                        {{ dir.colony || '' }}, {{ dir.cp || '' }},
                        {{ dir.municipality || '' }},
                        {{ dir.state || '' }}
                    </p>
                </div>
                <button mat-icon-button><mat-icon>edit</mat-icon></button>
            </div>
        </div>
    </div>
    <button class="w-full border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
        (click)="toggleAddresses()">
        <p class="button-small text-[#0E365A]">{{ showAllAddresses ? 'Ocultar direcciones' : 'Cambiar dirección' }}</p>
        <mat-icon>{{ showAllAddresses ? 'remove' : 'add' }}</mat-icon>
    </button>

    <!-- Botón para agregar dirección -->
    <button *ngIf="showAllAddresses" class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
        (click)="goToAddAddress()">
        <p class="button-small text-[#0E365A]">Agregar dirección</p>
        <mat-icon>add</mat-icon>
    </button>
</div>

<div>
    <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Nombre</h2>
    <mat-radio-group [(ngModel)]="selectedPatient" class="flex flex-col gap-2">
        <div class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
            <mat-icon class="flex-shrink-0">person</mat-icon>
            <div class="ml-2 flex-1 min-w-0">
                <p class="font-semibold truncate">{{ nameOwner }}</p>
                <p class="text-sm text-gray-500">Titular</p>
            </div>
            <mat-radio-button class="ml-2 flex-shrink-0" value="titular"></mat-radio-button>
        </div>

    <!-- DEPENDIENTES OCULTOS TEMPORALMENTE
        <div *ngIf="dependent.length > 0" class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
            <mat-icon class="flex-shrink-0">person</mat-icon>
            <div class="ml-2 flex-1 min-w-0">
                <p class="font-semibold truncate">{{ dependent[0].name }}</p>
                <p class="text-sm text-gray-500 truncate">{{ dependent[0].catalog.description }}</p>
            </div>
            <mat-radio-button class="ml-2 flex-shrink-0" [value]="dependent[0].name"></mat-radio-button>
        </div>

        <ng-container *ngIf="showAllDependents">
            <div *ngFor="let dep of dependent.slice(1)" class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
                <mat-icon class="flex-shrink-0">person</mat-icon>
                <div class="ml-2 flex-1 min-w-0">
                    <p class="font-semibold truncate">{{ dep.name }}</p>
                    <p class="text-sm text-gray-500 truncate">{{ dep.catalog.description }}</p>
                </div>
                <mat-radio-button class="ml-2 flex-shrink-0" [value]="dep.name"></mat-radio-button>
            </div>
        </ng-container>
    FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
    </mat-radio-group>

    <!-- DEPENDIENTES OCULTOS TEMPORALMENTE
    <button *ngIf="dependent.length > 1" class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center" (click)="toggleDependents()">
        <p class="button-small text-[#0E365A]">{{ showAllDependents ? 'Ocultar dependientes' : 'Ver más dependientes' }}</p>
        <mat-icon>{{ showAllDependents ? 'remove' : 'add' }}</mat-icon>
    </button>

    <button class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center" (click)="addNewDependent()">
        <p class="button-small text-[#0E365A]">Agregar nuevo dependiente</p>
        <mat-icon>add</mat-icon>
    </button>
    FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
</div>

<div>
    <h2 class="headline-04 mb-2 text-[#0E365A] my-4">¿Qué vehículo necesita el servicio?</h2>
    <mat-radio-group [(ngModel)]="selectedVehicle" class="flex flex-col gap-2" *ngIf="vehicles.length > 0">
        <!-- Primer vehículo -->
        <div class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 md:w-[327px] min-h-[60px]">
            <mat-icon class="flex-shrink-0">directions_car</mat-icon>
            <div class="ml-2 flex-1 min-w-0">
                <p class="font-semibold truncate">{{ vehicles[0].catalogbrand.description }} {{ vehicles[0].catalogsubbrand.description }}</p>
                <p class="text-sm text-gray-500 truncate">{{ vehicles[0].model }}, {{ vehicles[0].plates }}</p>
            </div>
            <mat-radio-button class="ml-2 flex-shrink-0" [value]="vehicles[0].id"></mat-radio-button>
        </div>

        <!-- Vehículos adicionales -->
        <ng-container *ngIf="showAllVehicles">
            <div *ngFor="let vehicle of vehicles.slice(1)"
                 class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 md:w-[327px] min-h-[60px]">
                <mat-icon class="flex-shrink-0">directions_car</mat-icon>
                <div class="ml-2 flex-1 min-w-0">
                    <p class="font-semibold truncate">{{ vehicle.catalogbrand.description }} {{ vehicle.catalogsubbrand.description }}</p>
                    <p class="text-sm text-gray-500 truncate">{{ vehicle.model }}, {{ vehicle.plates }}</p>
                </div>
                <mat-radio-button class="ml-2 flex-shrink-0" [value]="vehicle.id"></mat-radio-button>
            </div>
        </ng-container>
    </mat-radio-group>

    <!-- Botón para mostrar/ocultar vehículos adicionales -->
    <button *ngIf="vehicles.length >= 0"
            class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
            (click)="toggleVehicles()">
        <p class="button-small text-[#0E365A]">{{ showAllVehicles ? 'Ocultar vehículos' : 'Ver más vehículos' }}</p>
        <mat-icon>{{ showAllVehicles ? 'remove' : 'add' }}</mat-icon>
    </button>

    <!-- Botón para agregar vehículo -->
    <button *ngIf="showAllVehicles" class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
        (click)="goToAddVehicles()">
        <p class="button-small text-[#0E365A]">Agregar vehículo</p>
        <mat-icon>add</mat-icon>
    </button>
</div>

<div *ngIf="selectedVehicle">
    <div class="hidden flex items-center justify-between bg-[#D2E4FF29] border border-[#B0C4DE] rounded-full px-4 my-3 md:w-[327px]">
        <h2 class="paragraph-medium text-[#0E365A]"><strong>¿Su vehículo tiene blindaje?</strong></h2>
        <mat-radio-button [checked]="getSelectedVehicleShielding()" (click)="toggleShielding()"></mat-radio-button>
    </div>

    <div *ngIf="getSelectedVehicleShielding()" class="mt-2">
        <p class="text-sm text-gray-500 mb-1">Nivel de blindaje actual: {{ getSelectedVehicleShieldingLevel() }}</p>
        <p class="text-xs text-blue-600">El nivel de blindaje se basa en la información registrada del vehículo</p>
    </div>
</div>

<!--mat-progress-bar mode="determinate" [value]="progressValue" color="primary" class="my-2"></mat-progress-bar-->

<button class="bg-[#0E365A] text-white w-full py-2 my-3 rounded-full" (click)="goToStep(2)">
    Confirmar
</button>
